
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import AnalyticsWrapper from '../seo/AnalyticsWrapper';

interface SEOProviderProps {
  children: React.ReactNode;
}

const SEOProvider: React.FC<SEOProviderProps> = ({ children }) => {
  return (
    <HelmetProvider>
      <AnalyticsWrapper>
        {children}
      </AnalyticsWrapper>
    </HelmetProvider>
  );
};

export default SEOProvider;
